const villa_sec1_part1Location = (payload) => {
  return {
    type: "villasec1part1loc",
    payload,
  };
};

export default villa_sec1_part1Location;
